import { ANDROID_PLATFORM_NAME, IOS_PLATFORM_NAME, isIOS, isIosApp } from '../../core/util/device';
import { isClientSide } from '../../core/util/system';
import { getQueryParams } from '../../core/util/url';

// These are from Apple
export const SOLV_APPLE_ID = 1464601606;
export const SOLV_APPLE_PROVIDER_ID = 120007617;

// Google specific constants
export const SOLV_GOOGLE_PLAY_ID = 'com.solv';

export const hasAppUtmSource = () => {
  if (isClientSide()) {
    const qParams = getQueryParams(window.location.href);
    const utmSource = (qParams.utm_source ?? '').toLowerCase();
    return utmSource === IOS_PLATFORM_NAME || utmSource === ANDROID_PLATFORM_NAME;
  }

  return false;
};

export const downloadDriverFeatureFlagCheck = () => {
  const flag = (typeof window === 'undefined' ? process.env : window.CFG).FF_DOWNLOAD_DRIVER;
  return typeof flag === 'string' ? flag === 'true' : flag;
};

export const getSolvAppStoreLink = (campaignName = 'generic-solv-website-campaign') =>
  `https://apps.apple.com/app/apple-store/id${SOLV_APPLE_ID}?pt=${SOLV_APPLE_PROVIDER_ID}&ct=${campaignName}&mt=8`;

export const getSolvPlayStoreLink = (campaignName = 'generic-solv-website-campaign') =>
  `https://play.google.com/store/apps/details?id=${SOLV_GOOGLE_PLAY_ID}&referrer=utm_source%3D${campaignName}%26utm_medium%3Ddownload_driver%26anid%3Dadmob`;

export const getNativeStoreDownloadLink = (campaignName = 'generic-solv-website-campaign') =>
  isIOS() ? getSolvAppStoreLink(campaignName) : getSolvPlayStoreLink(campaignName);

export const downloadDriverCarouselVariants = {
  account: [
    {
      img: '/images/account/solv-logo.svg',
      title: 'Keep great care a couple taps away',
    },
    {
      img: '/images/account/Mom-daughter.svg',
      title: 'Book same-day care, from anywhere',
    },
    {
      img: '/images/account/Top-provider.svg',
      title: 'Find a top provider near you',
    },
    {
      img: '/images/account/telemed.svg',
      title: 'Choose an in-person or video visit',
    },
    {
      img: '/images/account/Man-on-phone.svg',
      title: 'Manage visits on-the-go',
    },
  ],
};
